import { useCallback } from 'react';
import ReactD3WordCloud from 'react-d3-cloud';
import { useWordsCount } from "./WordClound.hooks";

export type WordCloudProps = {
  sentence: string;
};

export const WordCloud = ({ sentence }: WordCloudProps) => {
  const data = useWordsCount(sentence.split(' '));
  const fontSize = useCallback(
    ({ value }) => value * 10,
    [],
  )
  return (
    <ReactD3WordCloud
      width={1000}
      height={800}
      data={data}
      fontSize={fontSize}
      padding={5}
    />
  )
}
